export const getConditionalValue = (
  value,
  defaultVal = undefined,
  { condition = Boolean, prefix, suffix } = {}
) => {
  return condition(value) ? prefix + value + suffix : defaultVal;
};

// if value is truthy, return "{prefix}{value}{suffix}" otherwise ""
export const getConditionalString = (value, prefix, suffix) =>
  getConditionalValue(value, "", {
    prefix,
    suffix,
  });

// if value is truthy, return "({value})" otherwise ""
//    if space prefix is true, return " ({value})"
export const getConditionalParenthesesString = (value, spacePrefix) =>
  getConditionalString(value, (spacePrefix ? " " : "") + "[ ", " ]");
